import clsx from 'clsx';

export const ArgumentItem = ({
  text,
  score,
  isPositive,
}: {
  text: string;
  score: number;
  isPositive: boolean;
}) => {
  return (
    <div
      className={clsx(
        'flex flex-col gap-3 rounded-lg border p-3',
        isPositive ? 'border-success' : 'border-error'
      )}
    >
      <div className="text-sm">
        <span className={clsx(isPositive ? 'text-success' : 'text-error')}>
          {score}
        </span>
        /10
      </div>
      <div>{text}</div>
    </div>
  );
};
